import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Building2, Save } from "lucide-react";
import { API } from "../lib/api";
import { refreshEmpresaCache } from "../lib/pdf";

const CAMPOS = [
  { key: "nome", label: "Nome / Razão social", placeholder: "IDENTIDADE GENTE" },
  { key: "cnpj", label: "CNPJ", placeholder: "00.000.000/0000-00" },
  { key: "telefone", label: "Telefone", placeholder: "(00) 00000-0000" },
  { key: "email", label: "E-mail", placeholder: "contato@empresa.com" },
  { key: "endereco", label: "Endereço", placeholder: "Rua, nº - Bairro - Cidade/UF" },
];

const Empresa = () => {
  const [form, setForm] = useState({ nome: "", cnpj: "", telefone: "", email: "", endereco: "" });
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    const carregar = async () => {
      try {
        const res = await axios.get(`${API}/empresa`);
        setForm({
          nome: res.data.nome || "",
          cnpj: res.data.cnpj || "",
          telefone: res.data.telefone || "",
          email: res.data.email || "",
          endereco: res.data.endereco || "",
        });
      } catch (error) {
        toast.error("Erro ao carregar dados da empresa");
      } finally {
        setLoading(false);
      }
    };
    carregar();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSalvando(true);
    try {
      await axios.put(`${API}/empresa`, form);
      refreshEmpresaCache();
      toast.success("Dados da empresa salvos! Eles já aparecem nos relatórios.");
    } catch (error) {
      toast.error("Erro ao salvar dados da empresa");
    } finally {
      setSalvando(false);
    }
  };

  if (loading) return <div>Carregando...</div>;

  return (
    <div className="space-y-6" data-testid="empresa-page">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">Dados da Empresa</h1>
        <p className="text-gray-600 dark:text-gray-300">
          Estas informações aparecem no cabeçalho de todos os relatórios em PDF, ao lado da logo.
        </p>
      </div>

      <Card className="max-w-2xl">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Building2 className="h-5 w-5 text-primary" />
            Informações do cabeçalho dos relatórios
          </CardTitle>
          <CardDescription>Preencha o que desejar exibir. Campos em branco são omitidos do PDF.</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="empresa-form">
            {CAMPOS.map((c) => (
              <div key={c.key}>
                <Label htmlFor={`empresa-${c.key}`}>{c.label}</Label>
                <Input
                  id={`empresa-${c.key}`}
                  value={form[c.key]}
                  onChange={(e) => setForm({ ...form, [c.key]: e.target.value })}
                  placeholder={c.placeholder}
                  data-testid={`empresa-${c.key}-input`}
                />
              </div>
            ))}
            <Button type="submit" disabled={salvando} data-testid="empresa-salvar-btn">
              <Save className="mr-2 h-4 w-4" />
              {salvando ? "Salvando..." : "Salvar dados da empresa"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default Empresa;
